import { createElement } from "react";
import { createBrowserRouter } from "react-router";
import { Root } from "./components/Root";

const hydrateFallbackElement = createElement("div", {
  style: {
    minHeight: "100vh",
    background: "var(--background)",
  },
});

export const router = createBrowserRouter([
  {
    path: "/",
    Component: Root,
    hydrateFallbackElement,
    children: [
      {
        index: true,
        lazy: async () => {
          const module = await import("./pages/Home");
          return { Component: module.Home };
        },
      },
      {
        path: "services",
        lazy: async () => {
          const module = await import("./pages/ServicesPage");
          return { Component: module.ServicesPage };
        },
      },
      {
        path: "blog",
        lazy: async () => {
          const module = await import("./pages/BlogStream");
          return { Component: module.BlogStream };
        },
      },
      {
        path: "blog/:slug",
        lazy: async () => {
          const module = await import("./pages/BlogPost");
          return { Component: module.BlogPost };
        },
      },
      {
        path: "portfolio",
        lazy: async () => {
          const module = await import("./pages/PortfolioStream");
          return { Component: module.PortfolioStream };
        },
      },
      {
        path: "portfolio/:slug",
        lazy: async () => {
          const module = await import("./pages/PortfolioDetail");
          return { Component: module.PortfolioDetail };
        },
      },
      {
        path: "contact",
        lazy: async () => {
          const module = await import("./pages/Contact");
          return { Component: module.Contact };
        },
      },
      {
        path: "mentions-legales",
        lazy: async () => {
          const module = await import("./pages/Legal");
          return { Component: module.MentionsLegales };
        },
      },
      {
        path: "cgv",
        lazy: async () => {
          const module = await import("./pages/Legal");
          return { Component: module.Cgv };
        },
      },
      {
        path: "confidentialite",
        lazy: async () => {
          const module = await import("./pages/Legal");
          return { Component: module.Confidentialite };
        },
      },
    ],
  },
]);
